import PropTypes from 'prop-types'
import { DietaryBadge } from '#src/common/components/badge'
import { ProductBadges } from './styles'

const ProductDietaryBadge = ({ suitableForVegans, suitableForVegetarians }) => {
  const dietaryBadge =
    (suitableForVegans && <DietaryBadge key='suitableForVegans' diet='vg' />) ||
    (suitableForVegetarians && (
      <DietaryBadge key='suitableForVegetarians' diet='v' />
    ))

  return <>{dietaryBadge && <ProductBadges>{dietaryBadge}</ProductBadges>}</>
}

ProductDietaryBadge.propTypes = {
  suitableForVegans: PropTypes.bool,
  suitableForVegetarians: PropTypes.bool
}

export default ProductDietaryBadge
